import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AssetsGenerateUrlService, AssetUIModel, ClientCoreModule } from '@thehubz/client/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'thehubz-asset-audio',
  templateUrl: './asset-audio.component.html',
  standalone: true,
  imports: [CommonModule, ClientCoreModule],
})
export class AssetAudioComponent implements OnInit {
  @Input() asset!: AssetUIModel;

  audioURL$!: Observable<string>;

  constructor(private assetsUrlService: AssetsGenerateUrlService) {}

  ngOnInit(): void {
    this.audioURL$ = this.assetsUrlService.getResizedPresignedUrl$(this.asset);
  }

  onError() {
    // could happen that the url expired, so we get a new one
    this.audioURL$ = this.assetsUrlService.getResizedPresignedUrl$(this.asset);
  }
}
